module.exports = __webpack_public_path__ + "static/media/valor3_11.617efbb5.png";